import { useTranslation } from "react-i18next";

import { Badge } from "@/components/Badge";
import Icon from "@/components/Icon/Icon";
import { HStack } from "@/components/Layout";
import { defaultNS } from "@/lib/i18n";

import { CertificationStatus } from "../../-constants";

import { getCertificationStatusBadgeVariant } from "./utils";

type Props = {
  certificationStatus: CertificationStatus;
};

export function CertificationStatusBadge({ certificationStatus }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.certification",
  });

  return (
    <Badge variant={getCertificationStatusBadgeVariant(certificationStatus)}>
      <HStack className="items-center gap-1">
        {certificationStatus === CertificationStatus.EFFECTIVE && (
          <Icon iconName="CircleDotIcon" colorVariant="primary" />
        )}
        {t(`certificationStatus.${certificationStatus}`)}
      </HStack>
    </Badge>
  );
}
